<template>
  <div id="ResourcesCenter">
    <a-form-model class="search-form" layout="inline" :model="search" @submit="searchList" @submit.native.prevent>
      <a-form-model-item label="资源标题">
        <a-input v-model.trim="search.name" :maxLength="30" allowClear placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="类型">
        <a-select v-model="search.fileType" allowClear placeholder="请选择">
          <a-select-option v-for="(item, index) in searchFileType" :value="index" :key="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit">查询</a-button>
        <a-button @click="searchReset" style="margin-left: 10px">重置</a-button>
      </a-form-model-item>

      <a-form-model-item class="search-use">
        <a-button @click="folder.visible = true" icon="folder-add" v-permission="`MarketResource.AddFolder`" html-type="button">新建文件夹</a-button>
        <a-dropdown v-permission="`MarketResource.Upload`">
          <a-button type="primary" icon="plus" html-type="button">上传资源</a-button>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-upload name="file" :multiple="true" :show-upload-list="false" :customRequest="uploadResourcesChange"> 上传文件 </a-upload>
            </a-menu-item>
            <a-menu-item>
              <a-upload name="file" :multiple="true" directory :show-upload-list="false" :customRequest="uploadResourcesChange"> 上传文件夹 </a-upload>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-form-model-item>
    </a-form-model>

    <a-breadcrumb separator=">" class="head-breadcrumb" v-show="$store.getters['file/getPaths'].length">
      <a-breadcrumb-item
        ><span @click="nextFolder(0)">{{ $route.name }}</span></a-breadcrumb-item
      >
      <a-breadcrumb-item v-for="(item, index) in $store.getters['file/getPaths']" :key="item.id">
        <span :title="item.name" class="name" @click="nextFolder(index + 1, item.id)">{{ item.name }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <div class="btn-group">
      <span @click="moveFile" v-permission="`MarketResource.MoveAll`"><a-icon type="swap" />移动</span>
      <span class="red" @click="delMultiple" v-permission="`MarketResource.DeleteAll`"><a-icon type="delete" />删除</span>
    </div>

    <a-table
      style="min-width: 800px"
      :columns="columns"
      rowKey="id"
      :row-selection="rowSelection"
      @change="handleTableChange"
      :pagination="table.tablePagination"
      :loading="table.tableLoading"
      :locale="table.locale"
      :dataSource="table.tableDataSource"
    >
      <div slot="name" class="table-name" slot-scope="text">
        <img :src="$getFileType(text.fileType).icon" style="width: 16px; height: 16px; margin-right: 4px" />
        <a-button @click="nextFolder(text)" v-if="!text.fileType" type="link" :title="text.name">{{ text.name }} </a-button>
        <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
      </div>
      <div slot="category" slot-scope="text" v-if="text.categoryName">
        <a-button @click="category(text)" type="link">{{ text.categoryName }}</a-button>
      </div>
      <div slot="type" slot-scope="text">
        {{ searchFileType[text.fileType] }}
        {{ text.fileType === 1 ? `（${suffix(text.fileName)}）` : '' }}
      </div>
      <div slot="size" slot-scope="text">
        {{ text.size > 1024 * 1024 ? (text.size / (1024 * 1024)).toFixed(2) + 'M' : text.size / 1024 < 1 ? (text.size ? text.size + 'B' : '--') : (text.size / 1024).toFixed(2) + 'KB' }}
      </div>
      <div slot="action" slot-scope="text" class="action">
        <a @click="edit(text)" v-permission="`MarketResource.Edit`" href="javascript:;">编辑</a>
        <a @click="view(text)" v-if="![0, 5].includes(text.fileType)" v-permission="`MarketResource.CheckFile`" href="javascript:;">查看</a>
        <a @click="download(text)" v-if="![0].includes(text.fileType)" v-permission="`MarketResource.Download`" href="javascript:;">下载</a>
        <a @click="tableContact(text)" v-permission="`MarketResource.Related`" href="javascript:;">关联</a>
        <a @click="del(text)" v-permission="`MarketResource.Delete.Item`" href="javascript:;" class="red">删除</a>
      </div>
    </a-table>

    <a-modal title="新建文件夹" :centered="true" v-model="folder.visible" :confirm-loading="folder.confirmLoading" @cancel="addFolderCancel" @ok="addFolderOk">
      <a-form-model layout="inline" :model="folder.data" ref="addFolderForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" :rules="folder.rules" style="width: 100%">
        <a-form-model-item label="名称" prop="name" style="width: 100%">
          <a-input v-model="folder.data.name" placeholder="请输入文件夹名称" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="preview.visible" :centered="true" title="预览" width="800px" :footer="null" destroyOnClose>
      <a-spin :spinning="preview.loading">
        <div v-if="preview.info.fileType === 3" style="padding: 30px">
          <my-audio :src="preview.src | filterUrl"></my-audio>
        </div>
        <div id="J_prismPlayer" style="height: 500px" v-if="preview.info.fileType === 4"></div>
        <div v-if="preview.info.fileType === 2" style="height: 500px">
          <img :src="preview.src | filterUrl" alt="" style="width: 100%; height: 500px; object-fit: cover" />
        </div>
      </a-spin>
    </a-modal>

    <a-modal title="编辑资源" :centered="true" width="650px" v-model="editFile.visible" :confirm-loading="editFile.confirmLoading" @cancel="editCancel" @ok="editOk">
      <a-form-model :model="editFile.data" ref="editForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" :rules="editFile.rules">
        <a-form-model-item label="资源标题" prop="editName">
          <a-input v-model="editFile.data.editName" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="所在目录">
          <a-cascader
            :options="editFile.options"
            ref="editFileCascader"
            v-model="editFile.data.path"
            :load-data="editLoadData"
            allowClear
            placeholder="请选择目录"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            change-on-select
          />
        </a-form-model-item>
        <a-form-model-item label="资源文件" v-show="editFile.data.fileType">
          <div v-if="!editFile.upload.name">
            <a-icon type="paper-clip" />
            {{ editFile.data.fileName }}&nbsp;&nbsp;
            <a-upload name="file" :multiple="true" :show-upload-list="false" :customRequest="editResourcesChange">
              <span class="red">替换</span>
            </a-upload>
          </div>
          <div v-else>
            <div style="display: flex; justify-content: space-between; align-items: center">
              {{ editFile.upload.name }}
              <a-icon @click="cancelEditUploadFile" style="cursor: pointer" type="close" />
            </div>
            <a-progress :percent="editFile.upload.progress" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal title="移动资源" :centered="true" width="650px" v-model="move.visible" :confirm-loading="move.confirmLoading" @ok="moveOk">
      <div class="move-wapper">
        移动到：
        <a-cascader
          :options="editFile.options"
          ref="moveCascader"
          v-model="move.path"
          :load-data="editLoadData"
          allowClear
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          change-on-select
        />
        <div @click="$refs.moveCascader.$el.click()" class="move-btn">修改</div>
      </div>
    </a-modal>

    <related-resource v-model="contact.visible" :info="contact.info"/>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import MyAudio from '@/components/audio/index.vue'
import Api from '@/requests/apis'
import RelatedResource from "@/components/relatedResource/index.vue"

const columns = [
  {
    title: '资源标题',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '类型',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: '大小',
    scopedSlots: { customRender: 'size' },
  },
  {
    title: '关联数',
    scopedSlots: { customRender: 'number' },
  },
  {
    title: '更新时间',
    sorter: true,
    dataIndex: 'updateTime',
  },
  {
    title: '上传时间',
    sorter: true,
    dataIndex: 'uploadTime',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

const TypeMap = {
  marketing: {
    name: '市场部',
    type: 1,
  },
  curriculum: {
    name: '课程部',
    type: 2,
  },
  productTechnology: {
    name: '产品技术部',
    type: 3,
  },
  gameDep: {
    name: '游戏部',
    type: 4,
  },
}
export default {
  name: 'index',
  components: { MyAudio, RelatedResource },
  data() {
    return {
      projects: [],
      projectId: '',
      fileType: [
        ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
        ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
        ['mp3', 'wav', 'wma'],
        ['mp4', 'flv', 'avi', 'mkv', 'mov', 'wmv'],
        ['rar', 'zip', '7z'],
      ],
      paths: [{ name: '公共资料' }],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      isSearch: false,
      search: {
        name: undefined,
        id: undefined,
        fileType: undefined,
        sortField: undefined,
        sortType: undefined,
      },
      columns,
      table: tableRelevant.call(this),
      selectedRowKeys: [],
      folder: {
        visible: false,
        confirmLoading: false,
        data: {
          name: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入文件夹名称', trigger: 'blur' },
            { max: 30, message: '名称最大长度30个字符', trigger: 'blur' },
          ],
        },
      },
      pageTimer: null,
      preview: {
        info: {},
        visible: false,
        src: '',
      },
      editFile: {
        data: {
          editName: undefined,
          fileName: '',
          path: [],
        },
        rules: {
          editName: [
            { required: true, message: '请输入资源名称', trigger: 'blur' },
            /* {max: 60, message: '名称最大长度30个字符', trigger: 'blur'},*/
          ],
        },
        upload: {
          progress: 0,
          name: '',
        },
        addFile: null,
        visible: false,
        confirmLoading: false,
        file: null,
        options: [
          {
            name: this.$route.name,
            id: undefined,
            children: [],
          },
        ],
      },
      contact: {
        visible: false,
        info: {},
      },
      move: {
        visible: false,
        confirmLoading: false,
        path: [],
      },
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
    marketProjects() {
      return this.$store.state.content.marketProjects
    },
    marketProjectIds() {
      return this.$store.state.content.marketProjects.map((v) => v.id)
    },
  },
  beforeDestroy() {
    $Bus.$off('RefreshResourcesList', this.refreshResourcesList)
    $Bus.$off('ReplaceFile', this.replaceFile)
  },
  mounted() {
    this.$message.config({
      maxCount: 1,
    })
    this.$store.commit('file/setPaths', [])
    const activeKey = this.$route.path.split('/').at(-1)
    this.activetTab = TypeMap[activeKey]
    this.getPageList()
    $Bus.$on('RefreshResourcesList', this.refreshResourcesList)
    $Bus.$on('ReplaceFile', this.replaceFile)
    $Bus.$emit('pageHeaderTitle', '公共资料')
    this.$store.commit('account/set_breadcrumb', this.$store.state.account.breadcrumb.slice(0, -1))
  },
  methods: {
    refreshResourcesList() {
      clearTimeout(this.pageTimer)
      this.pageTimer = setTimeout(() => {
        this.getPageList()
      }, 300)
    },
    replaceFile(value) {
      if (value.type === 'add') {
        this.editFile.addFile = value.data
      } else {
        this.editFile.upload = value
      }
    },
    getProjectAll() {
      let params = {
        type: 1,
        pageIndex: 1,
        pageSize: this.table.tablePagination.pageSize,
        isAll: false,
      }
      this.table.tableLoading = true
      this.$http.FileResource.pagelist(params).then((res) => {
        const { data, status, message } = res
          this.$store.commit('content/setMarketProjects', data.items)
          const activeKey = this.$route.path.split('/').at(-1)
          this.activetTab = TypeMap[activeKey]
          this.currentProject = this.marketProjects.find((v) => v.name == this.activetTab?.name)
          // this.search.id = this.currentProject.id
          this.getPageList()
        
      })
    },
    //获取能力评价列表
    getPageList(pageIndex) {
      if (this.search.name || typeof this.search.fileType === 'number') {
        this.search.id = undefined
        if (this.columns[1].title !== '所在位置') {
          this.columns.splice(1, 0, {
            title: '所在位置',
            scopedSlots: { customRender: 'category' },
          })
        }
        this.$store.commit('file/setPaths', [])
      } else {
        if (this.columns[1].title === '所在位置') {
          this.columns.splice(1, 1)
        }
      }
      let params = {
        type: this.activetTab.type,
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        isAll: !!this.search.name || typeof this.search.fileType === 'number',
        // isAll: false,
        ...this.search,
      }

      this.table.tableLoading = true
      this.$http.FileResource.pagelist(params).then((res) => {
        const { data, status, message } = res
          this.table.tableDataSource = data.items
          this.table.tablePagination.total = data.totalCount
          this.table.tablePagination.current = data.pageIndex
       
      }).finally(() => {
        this.table.tableLoading = false
      })
    },
    searchList() {
      this.$message.destroy()
      if (!this.search.name && typeof this.search.fileType !== 'number') {
        this.$message.warn('请输入查询条件')
        return
      }
      // this.isSearch = true;
      this.getPageList(1)
    },
    searchReset() {
      this.search.name = undefined
      this.search.fileType = undefined
      this.search.sortType = undefined
      this.search.sortField = undefined
      // this.isSearch = false;
      this.getPageList(1)
    },
    del(val) {
      this.$confirm({
        title: '删除资源',
        content: (h) => h('div', {}, ['资源将从所有关联课程和关联课时中删除,请谨慎操作', h('p', { style: { color: 'red' } }, '是否确认删除?')]),
        width: '450px',
        centered: true,
        okText: '确认删除',
        okType: 'danger',
        onOk: () => {
          this.table.tableLoading = true
          this.$http.FileResource.delete([val.id]).then((res) => {
            const { data, status, message } = res
              this.$message.success(message)
              this.selectedRowKeys = []
              this.getPageList(1)

          }).finally(() => {
            this.table.tableLoading = false
          })
        },
      })
    },
    delMultiple() {
      this.$message.destroy()
      if (!this.selectedRowKeys.length) {
        this.$message.warn('请选择资源')
        return
      }
      this.$confirm({
        title: `删除${this.selectedRowKeys.length}个资源`,
        content: (h) => h('div', {}, ['资源将从所有关联课程和关联课时中删除,请谨慎操作', h('p', { style: { color: 'red' } }, '是否确认删除?')]),
        width: '450px',
        centered: true,
        okText: '确认删除',
        okType: 'danger',
        onOk: () => {
          this.table.tableLoading = true
          this.$http.FileResource.delete(this.selectedRowKeys).then((res) => {
            const { data, status, message } = res
              this.$message.success(message)
              this.selectedRowKeys = []
              this.getPageList(1)
         
          }).finally(() => {
            this.table.tableLoading = false
          })
        },
      })
    },
    view(val) {
      this.$message.destroy()
      if (val.fileType === 5) {
        this.$message.error('文件不支持预览')
        return
      }
      if (!val.fileType) {
        this.nextFolder(val)
        return
      }
      this.preview = {
        visible: true,
        loading: false,
        info: val,
        src: process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + val.id,
      }
      if (val.fileType === 4) {
        const params = { id: val.id }
        this.$http.FileResource.getVideoPlayAuth(params).then((res) => {
          const { data, status, message } = res

            this.$nextTick(() => {
              new Aliplayer(
                {
                  id: 'J_prismPlayer',
                  width: '100%',
                  height: '500px',
                  autoplay: true,
                  vid: data.videoId, //播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                  playauth: data.playAuth, //播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
                },
                (player) => {
                  console.log('The player is created.')
                }
              )
            })
        
        }).catch(e => {
          this.preview.visible = false
        })
      }
      if (val.fileType === 2) {
        this.preview.loading = true
        const xhr = new XMLHttpRequest()
        xhr.open('GET', this.preview.src, true)
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.getters['account/token']())
        xhr.send(null)
        xhr.onload = () => {
          this.preview.src = window.URL.createObjectURL(xhr.response)
          this.preview.loading = false
        }
      }
      if (val.fileType === 1) {
        this.preview.visible = false
        const Params = {
          materialId: val.id,
        }
        this.$http.resourcesList.GeneratePresignedUri(Params).then((res) => {
          const { data } = res
          window.open(data)
        })
      }
    },
    download(val) {
      let url = process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + val.id
      const a = document.createElement('a')
      a.href = url
      a.download = val.name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    nextFolder(val, id) {
      const path = this.$store.getters['file/getPaths']
      if (typeof val === 'number') {
        this.$store.commit(
          'file/setPaths',
          path.filter((f, i) => i < val)
        )
        this.search.id = id
        this.getPageList(1)
      } else {
        this.category(val, 'next')
      }
    },
    category(val, type) {
      function set(id, arr, ele) {
        if (id) {
          for (let i = 0; i < ele.length; i++) {
            if (ele[i].id === id) {
              arr.unshift({
                name: ele[i].categoryName,
                id: id,
              })
              set(ele[i].categoryId, arr, ele)
            }
          }
        }
      }
      var paths = []
      set(val.categoryId, paths, val.categories)
      this.search.name = undefined
      this.search.fileType = undefined
      this.search.id = val.categoryId
      if (type === 'next') {
        paths.push({
          name: val.name,
          id: val.id,
        })
        this.search.id = val.id
      }
      this.$store.commit('file/setPaths', paths)
      this.getPageList(1)
    },
    handleTableChange(pagination, filters, sorter) {
      if (pagination.current === this.table.tablePagination.current) {
        return
      }
      this.search.sortField = sorter.columnKey
      this.search.sortType = sorter.order === 'descend' ? true : sorter.order === 'ascend' ? false : undefined
      this.getPageList()
    },
    uploadResourcesChange(data) {
      if (!this.checkFile(data.file)) {
        return
      }
      let suffix = this.suffix(data.file.name)
      this.$store.dispatch('file/uploadFile', {
        paramsType: this.activetTab.type,
        file: data.file,
        type: this.fileType[3].indexOf(suffix) > -1 ? 'video' : 'other',
      })
      /*if (this.fileType[3].indexOf(suffix) > -1) {
                this.$store.dispatch("file/uploadVideo", data.file);
            } else {
                this.$store.dispatch("file/uploadFile", data.file);
            }*/
    },
    checkFile(file) {
      const fileType = [...this.fileType[0], ...this.fileType[1], ...this.fileType[2], ...this.fileType[3], ...this.fileType[4]]
      const videoFile = this.fileType[3]
      const otherFile = [...this.fileType[1], ...this.fileType[2], ...this.fileType[0], ...this.fileType[4]]
      let suffix = this.suffix(file.name)
      if (fileType.indexOf(suffix) === -1) {
        this.$message.error(`文件【${file.name}】不支持上传`)
        return false
      }
      if (videoFile.indexOf(suffix) > -1 && file.size > 1024 * 1024 * 5000) {
        this.$message.error(`文件【${file.name}】大小超过5GB`)
        return false
      }
      if (otherFile.indexOf(suffix) > -1 && file.size > 200 * 1024 * 1024) {
        this.$message.error(`文件【${file.name}】大小超过200M`)
        return false
      }
      return true
    },
    addFolderOk() {
      this.$refs.addFolderForm.validate((valid) => {
        if (valid) {
          const path = this.$store.getters['file/getPaths']
          const obj = path.map((m) => m.name).join('/')
          const floderPath = obj ? obj + '/' + this.folder.data.name : this.folder.data.name
          let params = {
            type: this.activetTab.type,
            path: floderPath,
          }
          this.folder.confirmLoading = true
          this.$http.FileResource.add(params).then((res) => {
            const { data, status, message } = res
   
              this.folder.visible = false
              this.$message.success(message)
              this.getPageList(1)
              this.addFolderCancel()
           
          }).finally(() => {
            this.folder.confirmLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addFolderCancel() {
      this.folder.data.name = ''
      this.$refs.addFolderForm.resetFields()
    },
    async edit(val) {
      this.selectedRowKeys = []
      this.editFile.options = [
        {
          name: this.$route.name,
          id: 0,
          children: [],
          isLeaf: false,
        },
      ]
      const path = this.$store.getters['file/getPaths']
      this.editFile.data = {
        ...val,
        editName: val.name,
        path: [0, ...path.map((m) => m.id)],
      }
      if (this.search.name) {
        this.editFile.data.path = [0, val.categoryId]
      }
      await this.editLoadData(this.editFile.options)
      this.editFile.visible = true
      setTimeout(() => {
        if (this.$refs.editFileCascader.$el.children[1].firstChild) {
          this.$refs.editFileCascader.$el.children[1].firstChild.nodeValue = this.$route.name + (path.length ? ' / ' : '') + path.map((m) => m.name).join(' / ')
        }
      }, 300)
    },
    editLoadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1] || {}
      targetOption.loading = true

      const params = {
        id: targetOption.id || undefined,
        pageIndex: 1,
        pageSize: 9999,
        isAll: false,
        fileType: 0,
        type: this.activetTab.type,
      }
      return new Promise((resolve, reject) => {
        this.$http.FileResource.pagelist(params).then((res) => {
          const { data, status, message } = res
    
            if (!selectedOptions.length) {
              this.editFile.options = data.items.map((m) => ({
                ...m,
                isLeaf: false,
                disabled: m.id === this.editFile.data.id || this.selectedRowKeys.indexOf(m.id) > -1,
              }))
            } else {
              if (data.items.length) {
                targetOption.children = data.items.map((m) => ({
                  ...m,
                  isLeaf: false,
                  disabled: m.id === this.editFile.data.id || this.selectedRowKeys.indexOf(m.id) > -1,
                }))
              } else {
                targetOption.isLeaf = true
              }
              this.editFile.options = [...this.editFile.options]
            }
        
          resolve()
        }).finally(() => {
          targetOption.loading = false
        })
      })
    },
    editResourcesChange(data) {
      const suffix = data.file.name.substring(data.file.name.lastIndexOf('.') + 1)
      if (this.fileType[this.editFile.data.fileType - 1].indexOf(suffix) === -1) {
        this.$message.error('只能上传同类型文件')
        return
      }
      if (!this.checkFile(data.file)) {
        return
      }
      this.$store.commit('file/setReplaceFile', true)
      this.editFile.file = data.file
      this.editFile.data.uploadName = data.file.name
      if (this.fileType[3].indexOf(suffix) > -1) {
        this.$store.dispatch('file/video', data.file)
      } else {
        this.$store.dispatch('file/file', data.file)
      }
    },
    editOk() {
      this.$message.destroy()
      if (this.editFile.file && this.editFile.upload.progress < 100) {
        this.$message.warn('文件上传中...')
        return
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const params = {
            type: this.activetTab.type,
            name: this.editFile.data.editName,
            id: this.editFile.data.id,
            categoryId: this.editFile.data.path[this.editFile.data.path.length - 1] || undefined,
          }
          if (this.editFile.addFile) {
            params.fileItem = this.editFile.addFile
            params.fileItem.name = this.editFile.data.editName
          }
          this.editFile.confirmLoading = true
          this.$http.FileResource.update(params).then((res) => {
            const { data, status, message } = res
   
              this.$message.success(message || '操作成功')
              this.editCancel('ok')
              this.getPageList(null)
     
          }).finally(() => {
            this.editFile.confirmLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editCancel(val) {
      if (this.$store.getters['file/getReplaceFile'] && val !== 'ok') {
        try {
          this.cancelEditUploadFile()
        } catch (e) {
          console.error(e)
        }
      }
      this.editFile.upload = {
        progress: 0,
        name: '',
      }
      this.editFile.file = null
      this.editFile.addFile = null
      this.editFile.visible = false
      setTimeout(() => {
        this.$store.commit('file/setReplaceFile', false)
      }, 3000)
    },
    cancelEditUploadFile() {
      try {
        if (this.editFile.data.fileType === 4) {
          this.editFile.upload.uploader.stopUpload()
          const list = this.editFile.upload.uploader.listFiles()
          for (let i = 0; i < list.length; i++) {
            this.editFile.upload.uploader.cancelFile(i)
            this.editFile.upload.uploader.deleteFile(i)
          }
          this.editFile.upload.uploader.cleanList()
        } else {
          console.log(this.editFile.upload)
          this.$store.getters['file/getOSS']().abortMultipartUpload(this.editFile.upload.uploadName, this.editFile.upload.uploadId)
          this.$store.getters['file/getOSS']().deleteMulti([this.editFile.upload.uploadName])
        }
        this.$store.commit(
          'file/setUploadFileList',
          this.$store.getters['file/getUploadFileList'].filter((f) => f.uploadId !== this.editFile.upload.uploadId)
        )
      } catch (e) {
        console.error(e)
      }
      this.editFile.upload = {
        progress: 0,
        name: '',
      }
      this.editFile.file = null
      this.editFile.addFile = null
    },

    tableContact(val) {
      this.contact.info = val
      this.contact.visible = true
    },

    moveFile() {
      this.$message.destroy()
      if (!this.selectedRowKeys.length) {
        this.$message.warn('请选择资源')
        return
      }
      this.editFile.options = [
        {
          name: this.$route.name,
          id: 0,
          children: [],
          isLeaf: false,
        },
      ]
      this.move.path = [0]
      this.editLoadData(this.editFile.options)
      this.move.visible = true
    },
    moveOk() {
      const params = {
        fileIds: this.selectedRowKeys,
        categoryId: this.move.path[this.move.path.length - 1] || undefined,
      }
      this.move.confirmLoading = true
      this.$http.FileResource.batchRove(params).then((res) => {
        const { data, status, message } = res
          this.move.visible = false
          this.selectedRowKeys = []
          this.$message.success(message)
          this.getPageList(1)
       
      }).finally(() => {
        this.move.confirmLoading = false
      })
    },

    suffix(str, point) {
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
  },
}
</script>

<style scoped lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 5px;
}

#ResourcesCenter {
  position: relative;
  background-color: #fff;
  padding: 24px;
}

.table-name {
  display: flex;
  align-items: center;

  .ant-btn,
  span {
    display: inline-block;
    padding: 0;
    max-width: 200px;
    height: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.head-breadcrumb {
  display: flex;
  margin-bottom: 15px;

  span:not(:last-child) {
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }

  .name {
    display: inline-block;
    max-width: 130px;
    height: 23px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }
}

.search-use {
  float: right;

  .ant-btn {
    margin-left: 15px;
  }
}

.btn-group {
  display: inline-flex;
  border-radius: 40px;
  margin-bottom: 15px;
  align-items: center;
  background: #f3f9fe;
  text-align: center;
  height: 40px;

  span {
    display: inline-block;
    width: 99px;
    color: #4495e7;
    cursor: pointer;

    &:not(:last-child) {
      border-right: 1px solid #4495e7;
    }
  }

  .anticon {
    margin-right: 5px;
  }
}

.red {
  color: red !important;
  cursor: pointer;
}

.move-wapper {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 500px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding-left: 10px;

  .move-btn {
    width: 90px;
    height: 100%;
    text-align: center;
    border-left: 1px solid #d9d9d9;
    font-weight: bold;
    line-height: 35px;
    cursor: pointer;
  }

  .ant-cascader-picker {
    flex-grow: 1;
  }

  .ant-cascader-picker:focus /deep/ .ant-cascader-input {
    border: none !important;
    box-shadow: none !important;
  }

  /deep/ .ant-cascader-picker-label {
    padding-left: 5px;
  }

  /deep/ i {
    display: none;
  }

  /deep/ .ant-cascader-input {
    border: none;
    outline: none;
  }

  /deep/ .ant-cascader-input:focus {
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
